export const BUSINESS_NAME = 'Maridaki'
